import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0980. 支払タスク編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  name: string;
  description?: string;
  payment_schedule_detail_id: number;
  due_date?: string;
  user_id: number;
};

const updatePaymentTask = (props: Props): Promise<PaymentTask> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.id}`, props);
};

export const useUpdatePaymentTask = () => {
  return useMutation({
    mutationFn: updatePaymentTask,
  });
};
